import Cookie from "js-cookie";

class Messaging {
  constructor(element) {
    this.element = document.querySelector(element);

    this.cacheTimeout = 30 * 60 * 1000; // 30 mins

    this.renderMessage(this.element);
    this.handleClose(this.element);
  }

  async loadMessaging(element) {
    const path = element.dataset.load;

    // let data = [{ "msgid": "101", "id": "2196679", "active": "1", "ranking": "1", "message": "Due to high demand USPS orders may not ship for up to 3-4 business days.", "type": "alert", "date_added": "0000-00-00 00:00:00", "reseller_only": "0", "hero_id": "0", "home_ad_id": "0", "site_message_id": "101", "logo_id": "0", "repeat_type": "DAYS", "start_date": "2024-12-05", "end_date": "0000-00-00", "start_time": "00:00:00", "end_time": "00:00:00", "repeat_interval": "0", "end_count": "0", "sun": "1", "mon": "1", "tue": "1", "wed": "1", "thu": "1", "fri": "1", "sat": "1", "lock_to": "0", "weight": "0", "ab_set": "" }, { "msgid": "108", "id": "3724890", "active": "1", "ranking": "1", "message": "Glitch your gift list! Use code <a href=\"https:\/\/blog.adafruit.com\/2024\/12\/09\/gibson15\/\">gibson15<\/a> for 15% off the <a href=\"https:\/\/www.adafruit.com\/explore\/holiday-gift-guide-2024\">2024 Adafruit Holiday Gift Guide<\/a>!", "type": "sale", "date_added": "0000-00-00 00:00:00", "reseller_only": "0", "hero_id": "0", "home_ad_id": "0", "site_message_id": "108", "logo_id": "0", "repeat_type": "DAYS", "start_date": "2024-12-09", "end_date": "2024-12-30", "start_time": "00:00:00", "end_time": "23:59:00", "repeat_interval": "0", "end_count": "0", "sun": "1", "mon": "1", "tue": "1", "wed": "1", "thu": "1", "fri": "1", "sat": "1", "lock_to": "0", "weight": "0", "ab_set": "" }];
    // return Promise.resolve(data);

    if (!path) {
      return Promise.reject("No data-load attribute found");
    }

    // try to get from sessionStorage first
    if (window.sessionStorage) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(`cache-${path}`));

        if (cached?.timestamp && Date.now() < cached.timestamp) {
          return cached.data;
        }
      } catch (e) {
        console.error("Error reading from sessionStorage:", e);
      }
    }

    // otherwise fetch from server
    try {
      const response = await fetch(path);
      const data = await response.json();

      // cache the response
      if (window.sessionStorage) {
        sessionStorage.setItem(
          `cache-${path}`,
          JSON.stringify({
            timestamp: Date.now() + this.cacheTimeout,
            data,
          }),
        );
      }

      return data;
    } catch (error) {
      console.error("Error fetching messages:", error);
      return [];
    }
  }

  processForDisplay(data) {
    return data.filter((msg) => {
      const name = `seen_msg_${msg.msgid}`;
      return Cookie.get(name) !== "1";
    });
  }

  processForDismissable(data) {
    return data.map((msg) => ({ dismissable: true, ...msg }));
  }

  async renderMessage(element) {
    try {
      let data = await this.loadMessaging(element);

      data = this.processForDisplay(data);
      data = this.processForDismissable(data);

      element.innerHTML = this.renderTemplate(data);
    } catch (error) {
      console.error("Error rendering message:", error);
    }
  }

  handleClose(element) {
    element.addEventListener("click", (e) => {
      if (e.target.classList.contains("msg-close-btn")) {
        const messageElement = e.target.closest(".messaging-container");
        const messageId =
          messageElement.querySelector(".message").dataset.messageId;

        messageElement.style.display = "none";

        // set cookie to remember dismissed message
        const separate = window.location.hostname.split(".");
        separate.shift();
        const domain = `.${separate.join(".")}`;

        Cookie.set(`seen_msg_${messageId}`, "1", { path: "/", domain });
      }
    });
  }

  renderTemplate(messages) {
    return messages
      .map(
        (msg) => `
      <div role="alert" aria-labelledby="adafruit-message-${msg.msgid}" class="messaging-container messaging-${msg.type}">
        <div class="msg-container">
          <div id="adafruit-message-${msg.msgid}" class="message" data-message-id="${msg.msgid}">${msg.message}</div>
          ${msg.dismissable ? '<i class="fa fa-times msg-close-btn"></i>' : ""}
        </div>
      </div>
    `,
      )
      .join("");
  }
}

export function initMessaging(element) {
  return new Messaging(element);
}
